<template>
  <div>
    <div v-show="false"> {{getSearchResultsCounter}} </div>
    <div v-if="this.getSearchResults.length === 0">
      <v-layout row class="mt-4 align-center justify-center row fill-height">
        <v-card :class="ui.bkgdColor" :max-width="ui.cardMinWidth">
          <!-- <v-card-title primary-title>
            <v-layout row>
              <v-icon left :class="ui.chipColor"> emoji_transportation </v-icon>
              <a :class="ui.textTitle">
                Asset Tree is Loading
              </a>
            </v-layout>
          </v-card-title>
          <v-layout row class="ml-4 mr-4  mb-4 mt-4">
            <a :class="ui.textSubheading">
              Please contact Admin for info if issue.
            </a>
          </v-layout> -->
        </v-card>
      </v-layout>
    </div>
    <div v-else>
      <v-layout row>
        <v-flex xs12 lg10 offset-lg1 xl6 offset-xl3>
          <TreeListHeading/>
          <v-data-table
          :headers="headers"
          :items="getSearchResults"
          class="elevation-1"
          :total-items=this.maxRows
          :hide-actions=this.hideActions
          >
             <template slot="items" slot-scope="props">
               <td class="text-xs-left">
                 <!-- <v-btn flat>
                   <v-icon left :color="ui.btnColor">
                     text_snippet
                   </v-icon>
                   {{ defineTableContent(props.item).item0}}
                 </v-btn> -->
                 <!-- ID  -->
                 {{ defineTableContent(props.item).item0}}
               </td>
               <td class="text-xs-left">
                 <!-- TAG or Type -->
                 {{ defineTableContent(props.item).item1}}
               </td>
               <!-- TITLE -->
               <td class="text-xs-left">
                 {{ defineTableContent(props.item).item2}}
              </td>
              <!-- TYPE -->
               <td class="text-xs-left">
                 {{ defineTableContent(props.item).item3 }}
               </td>
               <td class="text-xs-left">
                 {{ defineTableContent(props.item).item4 }}
               </td>
               <td class="text-xs-left">
                 {{ defineTableContent(props.item).item5 }}
               </td>
               <td class="text-xs-right">
                 <v-layout row>
                   <v-spacer/>
                   <RegisterRead :listIndex="props.index"/>
                 </v-layout>
               </td>
             </template>
         </v-data-table>
         <!-- <TreeListBottom/> -->
         <v-layout class="mb-4"/>
         <v-layout class="mb-2"/>
       </v-flex>
      </v-layout>
    </div>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import RegisterRead from "@/data/register/components/RegisterRead";
import TreeListHeading from "@/asset/tree/components/TreeListHeading";
// import TreeListBottom from "@/asset/tree/components/TreeListBottom";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import getList from "@/data/cloud/firebase/mixins/getList.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";

export default {
  components: {
    RegisterRead,
    TreeListHeading
    // TreeListBottom
  },
  mixins: [dateFunctions, numberFunctions, apptheme, getList, displayFunctions],
  data() {
    return {
      maxRows: -1,
      btnSpinLoadMore: false,
      hideActions: true,
      barMovement: false,
      facilitySelect: false
    };
  },
  props: {
    date: {
      type: Object
    }
  },
  methods: {
    defineID(num) {
      return this.defineIDGShortLastSix(num);
    },
    defineTableContent(item) {
      let obj = {
        item0: "", // this is id
        item1: item.basic.id,
        item2: item.basic.title,
        item3: "",
        item4: "",
        item5: ""
      };
      // DEFINE ID
      obj.item0 = this.displayDocumentIDGTypeA(item.basic.tag, item.basic.idg);
      // DEFINE DATA SPECIFIC ITEMS
      if (item.basic.tag === "A1") {
        obj.item1 = item.basic.id;
        obj.item2 = item.basic.title;
        obj.item3 = item.char.type;
        obj.item4 = item.char.dis;
        obj.item5 = item.char.obj;
      } else {
        obj.item1 = "Undefined";
        obj.item2 = "Undefined";
        obj.item3 = "Undefined";
        obj.item4 = "Undefined";
        obj.item5 = "Undefined";
      }
      // RETURN OBJ
      return obj;
    }
  },
  computed: {
    ...mapGetters([
      "getSearchResults",
      "getSearchResultsCounter",
      "getPageTitle",
      "getRegisterInfo"
    ]),
    tag() {
      let tag = null;
      if (this.getSearchResults !== null) {
        tag = this.getSearchResults[0].basic.tag;
      }
      return tag;
    },
    headers() {
      let table = [
        { text: "ID", sortable: false },
        { text: "Tag", sortable: false },
        { text: "Name", sortable: false },
        { text: "Type", sortable: false },
        { text: "NA", sortable: false },
        { text: "NA", sortable: false },
        // { text: "Status", sortable: false, value: "name" },
        { text: "", sortable: false, align: "right" }
      ];

      if (this.tag === "A1") {
        table[1].text = "Tag";
        table[2].text = "Asset";
        table[3].text = "Type";
        table[4].text = "Discipline";
        table[5].text = "Function";
      }
      return table;
    }
  }
};
</script>
